const topSpecialSetSwiper = new Swiper(".special-set-items-sp", {
  simulateTouch: true,
  centeredSlides: true,
  shortSwipes: true,
  breakpoints: {
    1: {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    501: {
      spaceBetween: 0,
      slidesPerView: 1.6,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  },
});
